import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import Cards1 from '../Cards1';
/*import Cards2 from '../Cards2';*/
import Cards3 from '../Cards3';
import Cards4 from '../Cards4';


import HeroSection from '../HeroSection';
/*import Footer from '../Footer';*/

function Home() {
  return (
    <>
      <HeroSection />
      <Cards />
      <Cards1 />
     {/* <Cards2 /> */}
      <Cards3 />
      <Cards4 />
 
    
      {/*<Footer /> It's disable coz already define on App otherwise it'll handle double routing*/ } 
    </>
  );
}

export default Home;
